function initMixMatchConfigurators(container = document) {
  const configurators = container.querySelectorAll('.mixmatch-configurator');

  if (!configurators.length) return;

  configurators.forEach((configurator) => {
    if (configurator.dataset.initialized === 'true') return;
    configurator.dataset.initialized = 'true';

    const sectionId = configurator.dataset.sectionId;
    const defaultImage = configurator.dataset.defaultImage || '';
    const unavailableImage = configurator.dataset.unavailableImage || defaultImage;
    const basePrice = Number(configurator.dataset.basePrice ?? 0);
    const discountPercent = Number(configurator.dataset.discountPercent ?? 0);

    const mainImage = document.getElementById(`MixMatchMainImage-${sectionId}`);
    const variantInput = document.getElementById(`MixMatchVariantId-${sectionId}`);

    const rack1Input = configurator.querySelector('[data-role="rack1"]');
    const tilli1Input = configurator.querySelector('[data-role="tilli1"]');
    const rack2Input = configurator.querySelector('[data-role="rack2"]');
    const tilli2Input = configurator.querySelector('[data-role="tilli2"]');

   const subtotalRowEl = document.getElementById(`MixMatchSubtotalRow-${sectionId}`);
const subtotalEl = document.getElementById(`MixMatchSubtotal-${sectionId}`);
const discountRowEl = document.getElementById(`MixMatchDiscountRow-${sectionId}`);
const discountEl = document.getElementById(`MixMatchDiscount-${sectionId}`);
const finalPriceEl = document.getElementById(`MixMatchFinalPrice-${sectionId}`);

    const propRack1 = document.getElementById(`PropRack1-${sectionId}`);
    const propTilli1 = document.getElementById(`PropTilli1-${sectionId}`);
    const propRack2 = document.getElementById(`PropRack2-${sectionId}`);
    const propTilli2 = document.getElementById(`PropTilli2-${sectionId}`);
    const propConfig = document.getElementById(`PropConfig-${sectionId}`);
    const propComboKey = document.getElementById(`PropComboKey-${sectionId}`);
    const propFinalPrice = document.getElementById(`PropFinalPrice-${sectionId}`);

    const jsonEl = document.getElementById(`MixMatchData-${sectionId}`);
    if (!jsonEl) return;

    let mixData = {};
    try {
      mixData = JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error('Mix & Match JSON kon niet worden gelezen', error);
      return;
    }

    const rackLabels = mixData.rackLabels || {};
    const tilliLabels = mixData.tilliLabels || {};
    const tilliPrices = mixData.tilliPrices || {};
    const rackPairPrices = mixData.rackPairPrices || {};
    const setSurcharge = Number(mixData.setSurcharge || 0);
    const imageMap = mixData.imageMap || {};
    const comboToVariantMap = mixData.comboToVariantMap || {};
    const variantAvailabilityMap = mixData.variantAvailabilityMap || {};

    const submitButton = configurator.querySelector('button[type="submit"]');
    const submitButtonText = submitButton ? submitButton.querySelector('span') : null;

    const rackOrder = ['mc', 'mv', 'sc', 'sv'];
    const tilliOrder = ['sp', 'si', 'ss'];
    const preloadedImages = new Set();

    function formatMoney(value) {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    }

    function getValue(input) {
      return input ? input.value : '';
    }

    function preloadImage(src) {
      if (!src || preloadedImages.has(src)) return;
      preloadedImages.add(src);

      const img = new Image();
      img.src = src;
    }

    function getSortedRackPairKey(rackA, rackB) {
      return [rackA, rackB]
        .sort((a, b) => rackOrder.indexOf(a) - rackOrder.indexOf(b))
        .join('|');
    }

    function getNormalizedComboKey() {
      const pairA = {
        rack: getValue(rack1Input),
        tilli: getValue(tilli1Input)
      };

      const pairB = {
        rack: getValue(rack2Input),
        tilli: getValue(tilli2Input)
      };

      const sortedPairs = [pairA, pairB].sort((a, b) => {
        const rackDiff = rackOrder.indexOf(a.rack) - rackOrder.indexOf(b.rack);
        if (rackDiff !== 0) return rackDiff;

        return tilliOrder.indexOf(a.tilli) - tilliOrder.indexOf(b.tilli);
      });

      return [
        sortedPairs[0].rack,
        sortedPairs[0].tilli,
        sortedPairs[1].rack,
        sortedPairs[1].tilli
      ].join('|');
    }

    function updateImage(comboKey) {
  if (!mainImage) return;

  const mappedVariantId = comboToVariantMap[comboKey];
  const hasVariant = Boolean(mappedVariantId);
  const isAvailable = variantAvailabilityMap[comboKey] === true;

  let nextImage = defaultImage;

  if (!hasVariant || !isAvailable) {
    nextImage = unavailableImage;
  } else if (imageMap[comboKey]) {
    nextImage = imageMap[comboKey];
  }

  if (!nextImage) return;

  const currentSrc = mainImage.getAttribute('src') || '';
  if (currentSrc === nextImage) return;

  preloadImage(nextImage);
  mainImage.src = nextImage;
}

    function updateProperties(comboKey, finalPrice) {
      const rack1Label = rackLabels[getValue(rack1Input)] || getValue(rack1Input);
      const tilli1Label = tilliLabels[getValue(tilli1Input)] || getValue(tilli1Input);
      const rack2Label = rackLabels[getValue(rack2Input)] || getValue(rack2Input);
      const tilli2Label = tilliLabels[getValue(tilli2Input)] || getValue(tilli2Input);

      const displayConfig = `${rack1Label} + ${tilli1Label} | ${rack2Label} + ${tilli2Label}`;

      if (propRack1) propRack1.value = rack1Label;
      if (propTilli1) propTilli1.value = tilli1Label;
      if (propRack2) propRack2.value = rack2Label;
      if (propTilli2) propTilli2.value = tilli2Label;
      if (propConfig) propConfig.value = displayConfig;
      if (propComboKey) propComboKey.value = comboKey;
      if (propFinalPrice) propFinalPrice.value = finalPrice.toFixed(2);
    }

    function updatePrices() {
      const rackPairKey = getSortedRackPairKey(getValue(rack1Input), getValue(rack2Input));
      const rackPairPrice = Number(rackPairPrices[rackPairKey] || 0);
      const tilli1Price = Number(tilliPrices[getValue(tilli1Input)] || 0);
      const tilli2Price = Number(tilliPrices[getValue(tilli2Input)] || 0);

      const subtotal = rackPairPrice + tilli1Price + tilli2Price + basePrice + setSurcharge;
      const hasDiscount = discountPercent > 0;
      const discountAmount = hasDiscount ? subtotal * (discountPercent / 100) : 0;
      const finalPrice = Number((subtotal - discountAmount).toFixed(2));

      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);

if (subtotalRowEl) {
  subtotalRowEl.style.display = hasDiscount ? '' : 'none';
}

if (discountRowEl) {
  discountRowEl.style.display = hasDiscount ? '' : 'none';
}

      if (discountEl) {
        discountEl.textContent = hasDiscount ? `-${formatMoney(discountAmount)}` : '';
      }

      if (finalPriceEl) finalPriceEl.textContent = formatMoney(finalPrice);

      return finalPrice;
    }

    function updateConfigurator() {
      const comboKey = getNormalizedComboKey();

      updateImage(comboKey);
      const finalPrice = updatePrices();
      updateProperties(comboKey, finalPrice);

      const mappedVariantId = comboToVariantMap[comboKey];
      const hasVariant = Boolean(mappedVariantId);
      const isAvailable = variantAvailabilityMap[comboKey] === true;

      if (hasVariant && isAvailable) {
        if (variantInput) {
          variantInput.value = mappedVariantId;
        }

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-disabled');
        }

        if (submitButtonText) {
  submitButtonText.textContent = window.themeStrings?.add_to_cart || 'Toevoegen aan winkelwagen';
}
      } else {
        if (variantInput) {
          variantInput.value = '';
        }

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-disabled', 'true');
        }

        if (submitButtonText) {
  submitButtonText.textContent = hasVariant
    ? (window.themeStrings?.sold_out || 'Uitverkocht')
    : (window.themeStrings?.unavailable_combo || 'Deze combinatie is niet mogelijk');
}

        console.warn(`Combinatie niet beschikbaar: ${comboKey}`);
      }
    }

    configurator.querySelectorAll('[data-role-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const role = button.dataset.roleButton;
        const value = button.dataset.value;
        const hiddenInput = configurator.querySelector(`[data-role="${role}"]`);

        if (!hiddenInput || hiddenInput.value === value) return;

        hiddenInput.value = value;

        configurator.querySelectorAll(`[data-role-button="${role}"]`).forEach((btn) => {
          btn.classList.remove('is-active');
        });

        button.classList.add('is-active');
        updateConfigurator();
      });
    });

    [rack1Input, tilli1Input, rack2Input, tilli2Input].forEach((input) => {
      if (input && input.tagName === 'SELECT') {
        input.addEventListener('change', updateConfigurator);
      }
    });

    preloadImage(defaultImage);
    Object.values(imageMap).slice(0, 8).forEach(preloadImage);

    updateConfigurator();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMixMatchConfigurators(document));
} else {
  initMixMatchConfigurators(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initMixMatchConfigurators(event.target);
});